module.exports = __webpack_public_path__ + "static/media/footer_get-started-now.dbe5568a.png";